import { readPackageJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';
import type { WixDependency } from '@wix/cli-app-manifest';
import semver from 'semver';

export async function loadWixFrontendDependencies(
  projectFolder: string
): Promise<WixDependency[]> {
  const packageJson = await readPackageJson(projectFolder);

  const allDependencies = {
    ...packageJson.peerDependencies,
    ...packageJson.devDependencies,
    ...packageJson.dependencies,
  };

  const wixFrontendDependencies: WixDependency[] = Object.entries(
    allDependencies
  )
    .filter(([packageName]) => isWixFrontendDependency(packageName))
    .map(([packageName, versionRange]) =>
      fromNpmDependencyToWixDependency(packageName, versionRange)
    );

  return wixFrontendDependencies;
}

const isWixFrontendDependency = (packageName: string) => {
  return packageName.startsWith('@wix/site-');
};

const fromNpmDependencyToWixDependency = (
  packageName: string,
  versionRange: string
): WixDependency => {
  return {
    packageName,
    version: getMajorVersionFromRange(packageName, versionRange),
  };
};

const getMajorVersionFromRange = (
  packageName: string,
  versionRange: string
) => {
  let version: number | null;

  try {
    version = semver.minVersion(versionRange)?.major ?? null;
  } catch {
    version = null;
  }

  if (!version) {
    throw new CliError({
      code: CliErrorCode.InvalidSiteFrontendPackageVersion({
        packageName,
        versionRange,
      }),
      cause: null,
    });
  }

  return version;
};
